<template>
  <div>
    
    <app-header :sysco="sysco"></app-header>
    <!--div v-if="loading == true" class="text-center mt-5">
      Loading...
      <div class="container">
        <div class="spinner-border mt-2" style="width: 5rem; height: 5rem;" role="status"></div>
      </div>
    </div-->

    <div class="modal fade" id="ConfirmDelete"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("delete_warning")}}</h5>
          </div>
          <div class="modal-body">
            <p><strong>{{wintodelete.name}}</strong></p>
            <p>{{caption("delete_window_sure")}}</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="windowDelete(wintodelete.id)" data-dismiss="modal">{{caption("addwin_Yes")}}</button>
            <button type="button" class="btn btn-secondary" data-dismiss="modal">{{caption("addwin_No")}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="CopyWindowName"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("addwin_EnterWindowName")}}</h5>
          </div>
          <div class="modal-body">
            <label class="label">{{caption("addwin_WindowName")}}</label>
            <input type="text" class="input form-control" required v-model.trim="winName" />
            <div class="text-danger" v-if="winEmpty">{{caption("addwin_Required")}}</div>
            <div class="mt-3">
              <span><button class="btn btn-small btn-primary" @click = "winCopySend()">{{caption("Submit")}}</button></span>
              <span><button class="btn btn-small btn-danger" @click = "wincopyModalHide()">{{caption("Cancel")}}</button></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" id="PDFPagesSelection"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content centered">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("pdf_pdfselection")}}</h5>
          </div>
          <div class="modal-body">
            <div align="middle"><button :class="firstpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'" style="width: 400px" @click="setfirstpage()">{{caption("pdf_firstpage")}}</button></div>
            <div align="middle"><button :class="sashpage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'" style="width: 400px" @click="setsashpage()">{{caption("pdf_sashpage")}}</button></div>
            <div align="middle"><button :class="framepage == '1' ? 'btn btn-small btn-primary mb-2' : 'btn btn-small btn-light mb-2'" style="width: 400px" @click="setframepage()">{{caption("pdf_framepage")}}</button></div>
            <div class="mt-4" align="middle">
            <span><button class="btn btn-small btn-primary"  @click = "pdfpageshide()">{{caption("Submit")}}</button></span>
            <span><button class="btn btn-small btn-danger" @click = "pdfpagesmodalhide()">{{caption("Cancel")}}</button></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <span><button type="button" class="btn btn-info btn-sm my-2" @click="starttour">{{caption("tour_tour")}}</button></span>
      <div class="lead">{{proj.customerName}}</div>
      <div class="lead" style="color: blue;"><strong>{{proj.projectName}}</strong></div>
      <hr>
      <div class="display-4">{{caption("winlist_Windows")}}</div>
      <hr>

      <div class="modal fade" id="UploadModal"  tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{caption("upload_status")}}</h5>
          </div>
          <div class="modal-body">
            <div v-if="invalidfile == true">
              <p>{{caption("upload_invalidfile")}}</p>
            </div>
            <div v-if="errorlist != null">
            <p>{{caption("upload_notcreated")}}</p>
            </div>
            <p></p>
            <div v-if="errorlist != null">
              <div v-for="e in Object.keys(errorlist)">
                <h3>{{e}}</h3>
                  <div v-if="errorlist[e].fb1Error != ''">
                    <p>{{errorlist[e].fb1Error}}</p>
                  </div>
                  <div v-if="errorlist[e].fb2Error != ''">
                    <p>{{errorlist[e].fb2Error}}</p>
                  </div>
                  <div v-if="errorlist[e].fhError != ''">
                    <p>{{errorlist[e].fhError}}</p>
                  </div>
                  <div v-if="errorlist[e].aError != ''">
                    <p>{{errorlist[e].aError}}</p>
                  </div>
                  <div v-if="errorlist[e].w1Error != ''">
                    <p>{{errorlist[e].w1Error}}</p>
                  </div>
                  <div v-if="errorlist[e].w2Error != ''">
                    <p>{{errorlist[e].w2Error}}</p>
                  </div>
                  <div v-if="errorlist[e].ventError != ''">
                    <p>{{errorlist[e].ventError}}</p>
                  </div>
                  <div v-if="errorlist[e].magnetError != ''">
                    <p>{{errorlist[e].magnetError}}</p>
                  </div>
                  <div v-if="errorlist[e].snapperError != ''">
                    <p>{{errorlist[e].snapperError}}</p>
                  </div>
                  <div v-if="errorlist[e].hingeError != ''">
                    <p>{{errorlist[e].hingeError}}</p>
                  </div>
                  <div v-if="errorlist[e].chronoError != ''">
                    <p>{{errorlist[e].chronoError}}</p>
                  </div>
                  <div v-if="errorlist[e].handleError != ''">
                    <p>{{errorlist[e].handleError}}</p>
                  </div>
              </div>
            </div>
            <div v-if="errorlist == null && invalidfile == false">
                {{caption("upload_created")}}
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal" data-dismiss="modal">{{caption("upload_close")}}</button>
          </div>
        </div>
      </div>
    </div>
      <v-tour v-if="language == 'Nederlands'" name="WindowTour" :steps="windows != null ? stepswithNED : stepswithoutNED" :callbacks="myCallbacks" :options="myOptionsNED"></v-tour>
      <v-tour v-else-if="language == 'Chinese'" name="WindowTour" :steps="windows != null ? stepswithCHI : stepswithoutCHI" :callbacks="myCallbacks" :options="myOptionsCHI"></v-tour>
      <v-tour v-else-if="language == 'Portugues'" name="WindowTour" :steps="windows != null ? stepswithPOR : stepswithoutPOR" :callbacks="myCallbacks" :options="myOptionsPOR"></v-tour>
      <v-tour v-else name="WindowTour" :steps="windows != null ? stepswithENG : stepswithoutENG" :callbacks="myCallbacks" :options="myOptionsENG"></v-tour>
      <button type="button" data-intro='Hello step one!' style="font-size: 20px" class="btn btn-outline-primary btn-sm mb-3 v-step-0" @click="showProjectlist()"><i class="fas fa-chevron-left mr-2"></i>{{caption("winlist_Back")}}</button>
      <button v-if="getprojreadonly(proj.id) == 0" type="button" style="font-size: 20px" class="btn btn-primary btn-sm mb-3 v-step-1" @click="windowCreate()"><i class="fas fa-plus-square mr-2"></i>{{caption("winlist_AddWindow")}}</button>
      <span  v-if="sysco == 2 || sysco == 7" style="float:right">
        <label class="btn btn-secondary mb-3" style="font-size: 20px">{{uploadcaption}}<input class= "btn btn-secondary mb-3" style="display: none" type="file" id="file" ref="file" v-on:change="handleFileUpload()"/></label>
        <button v-if="fileuploading == false" class="btn btn-primary mb-3" style="font-size: 20px" v-on:click="submitFile()"><i class="fas fa-file-upload"></i> {{caption("upload_send")}}</button>
        <button v-if="fileuploading == true" class="btn btn-primary mb-3 disabled" style="font-size: 20px"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> {{caption("upload_wait")}}</button>
      </span>
      <input type="text" style="font-size: 16px" class="input form-control mb-2 v-step-2" v-model="searchwin"/>
      <span class="dropdown">
          <button class="btn btn-secondary btn-sm dropdown-toggle my-2" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{caption(sortoptions)}}
          </button>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <a class="dropdown-item" href="#" @click="setSort('byName')">{{caption('byName')}}</a>
            <a class="dropdown-item" href="#" @click="setSort('oldnew')">{{caption('oldnew')}}</a>
            <a class="dropdown-item" href="#" @click="setSort('newold')">{{caption('newold')}}</a>
          </div>
        </span>
      <div :style="tour == true ? 'z-index:-1; position:relative;' : ''">
        
        <div  class="card mb-2 border border-dark" v-for="w in windows" v-bind:key="w.id">
          <div class="card-header" :id="w.id" :style="w.valid == true ? '' : 'background-color: red;'">
              <h2><span class="v-step-3" :style="w.valid == true ? '' : 'color:white;'">{{w.name}}</span> <span class="v-step-4" :style="w.valid == true ? '' : 'color:white;'"><small>[{{w.quantity}}]</small></span></h2>
              <button v-if="getprojreadonly(w.projectId) == 0" type="button" :class="w.valid == true ? 'btn btn-sm btn-outline-primary mr-1 v-step-5' : 'btn btn-sm btn-outline-light mr-1 v-step-5'" @click="windowEdit(w.id)"><i class="fas fa-pen fa-lg mr-1" ></i>{{caption("Edit")}}</button>
              <button v-if="w.valid == true && getprojreadonly(w.projectId) == 0" type="button" class="btn btn-sm btn-outline-primary mr-1 v-step-6" @click="windowCopy(w)"><i class="far fa-copy fa-lg mr-1" ></i>{{caption("Copy")}}</button>
              <button v-if="getprojreadonly(w.projectId) == 0" type="button" :class="w.valid == true ? 'btn btn-sm btn-outline-danger mr-5 v-step-7' : 'btn btn-sm btn-outline-light mr-5 v-step-7'" @click="showConfirmDelete(w)"><i class="fas fa-trash-alt"></i></button>
              
          </div>
          <div class="card-body" :style="w.valid == true ? '' : 'background-color: lightgray;'">
            <div class="container">
            <div class="row">
              <div class="col-lg-4">
                <div v-if="w.valid == true" class="card-img-top my-2 ml-2 v-step-8" >
                  <window-graph :type="w.windowType" :dir="w.openDir" :hinge="w.hingeType" :handle="handleBMP(w.handleAN)" :Fb1="w.fb1" :Fb2="w.fb2" :Fh="w.fh" :A="w.a" :W1="w.weight1" :W2="w.weight2" :dim="dimension" :scale="scale" :profile="w.profile" :config="0"></window-graph>
                </div>
              </div>
                <div class="col-lg-8">
                  <div class="mb-2"><button v-if="w.valid == false" class="btn btn-danger"><h1><strong>{{caption("upload_errors")}}</strong></h1></button></div>
                  <div><span class="badge my-2 v-step-9" :class="w.bulk == 0 ? 'badge-primary' : 'badge-success'">{{w.bulk == 0 ? caption("Set") : caption("Bulk")}}</span></div>
                  <div class= "v-step-10"><h4> Chrono <strong>{{caption(chrono(w.chrono))}}</strong> <small>{{setgroove == false ? '[' + groove(w.groove) + ']' : '' }}</small></h4></div>
                  <div v-if="w.chrono == 40" class="my-2" ><img class="centered-and-cropped" src="/src/assets/RC2.jpg" height="40" width="50"></div>
                  <div v-if="w.chrono == 50" class="my-2" ><img class="centered-and-cropped" src="/src/assets/SKGxx.jpg" height="40" width="50"></div>
                  <div class="v-step-11"><h5 class="text-primary">{{caption(hinge(w.hingeType))}}</h5></div>
                  <div v-if="(w.windowType != 50 && w.windowType != 55)" class="v-step-12"><h5 class="text-secondary">{{w.handleAN != 'NONE' ? caption(handle(w.handleType)) : ''}} {{w.handleAN != 'NONE' ? handleAN(w.handleAN) : caption("addwin_NoHandle")}}</h5></div>
                  <button v-if="w.valid == true" type="button" class="btn btn-sm btn-outline-primary v-step-13" @click="windowBom(w)"><i class="far fa-list-alt fa-lg mr-1"></i>{{caption("winlist_BOM")}}</button>
                  
                  <button v-if="loading == false && w.valid == true" type="button" class="btn btn-sm btn-outline-success v-step-14" @click="windowPdf(w)"><i class="far fa-file-pdf fa-lg mr-1"></i>PDF</button>
                  <button v-if="loading == false && w.valid == true" type="button" class="btn btn-sm btn-outline-secondary v-step-15" @click="genericPdf(w)"><i class="far fa-file-pdf fa-lg mr-1"></i>GENERIC PDF</button>
                  <button v-if="loading == true && w.id != selWin" type="button" class="btn btn-sm btn-outline-success disabled"><i class="far fa-file-pdf fa-lg mr-1"></i>PDF</button>
                  <button v-if="loading == true && w.id == selWin" type="button" class="btn btn-sm btn-outline-success disabled"><span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Please wait...</button>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
      <a id="back-to-top" href="#" class="btn btn-primary btn-lg back-to-top" role="button"><i class="fas fa-chevron-up mr-2"></i>Top</a>
    </div>
</template>

<script>
import AppHeader from "../intro/AppHeader";
import WindowGraph from "./WindowGraph";
import store from '../../ClientApp/store';
import { mapGetters } from "vuex";
import steps from '../../ClientApp/helpers/window-steps';

export default {
  data: function(){
    return {
      dimension: true,
      scale: 10,
      projectId: 0,
      selWin: 0,
      searchwin: "",
      file: '',
      uploadcaption: '',
      stepswithoutENG: steps.stepswithoutENG,
      stepswithENG: steps.stepswithENG,
      stepswithoutCHI: steps.stepswithoutCHI,
      stepswithCHI: steps.stepswithCHI,
      stepswithoutNED: steps.stepswithoutNED,
      stepswithNED: steps.stepswithNED,
      stepswithoutPOR: steps.stepswithoutPOR,
      stepswithPOR: steps.stepswithPOR,
      tour: false,
      winName: null,
      winNameEmpty: false,
      winId: null,
      copywindow: null,
      myCallbacks: {
        onStart: this.myTourStart,
        onStop: this.myTourStop
      },
      myOptionsNED: {
          labels: {
            buttonSkip: 'Verlaat tour',
            buttonPrevious: 'Vorige',
            buttonNext: 'Volgende',
            buttonStop: 'Einde'
          }
        },
        myOptionsENG: {
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },
        myOptionsCHI: {
          labels: {
            buttonSkip: '跳过演示说明',
            buttonPrevious: '上一步',
            buttonNext: '下一步',
            buttonStop: '演示结束'
          }
        },
        myOptionsPOR: {
          labels: {
            buttonSkip: 'Skip tour',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
          }
        },
      wintodelete: 0,
      sortoptions: this.$store.getters.getWindowSortOptions,
      firstpage: '1',
      sashpage: '1',
      framepage: '1',
    }
  },
  components: {
    AppHeader,
    WindowGraph
  },
  computed: {
    windows() {
      var w = this.$store.getters.getWindows;
      var so = this.$store.getters.getWindowSortOptions;
      if (w != null){
          var wins = w.filter(w => w.name.toUpperCase().includes(this.searchwin.toUpperCase()));
          if (so == 'newold'){
            wins.sort(function(a,b){
              if (a.id > b.id ) return -1;
              if (a.id < b.id ) return 1;
              return 0
            })
          }
          if (so == 'oldnew'){
            wins.sort(function(a,b){
              if (a.id < b.id ) return -1;
              if (a.id > b.id ) return 1;
              return 0
            })
          }
          if (so == 'byName'){
            wins.sort(function(a,b){
              var nameA = a.name.toLowerCase(), nameB = b.name.toLowerCase();
              if (nameA < nameB ) return -1;
              if (nameA > nameB  ) return 1;
              return 0
            })
          }
          if (this.tour == false)
            return wins;
          else
            return wins.slice(0,1);
        }
      else
        return w;
    },
    proj() {
      var p = this.$store.getters.getProjectById(this.pid);
      return p;
    },
    pid() {
      return this.$route.params.id;
    },
    bom() {
      return this.$store.state.bom;
    },
    loading() {
      return this.$store.state.loading;
    },
    sysco(){
      return this.$store.getters.getAuth.systemCompany;
    },
    fileuploading(){
      return this.$store.state.fileuploading;
    },
    errorlist(){
      return this.$store.state.errorlist;
    },
    invalidfile(){
      return this.$store.state.invalidfile;
    },
    language(){
      return this.$store.state.auth.language;
    },
    setgroove(){
      return this.$store.getters.getAuth.setGroove;
    },
    winEmpty(){
      if (this.winNameEmpty) return true
      else return false
    },
    ...mapGetters(['getChrono', 'getOpDir', 'getHinge', 'getHandle', 'getGroove', 'getErrorList'])
  },
  
  
  methods: {
    windowCreate: function () {
      this.$store.commit("getProject", this.proj);
      this.$router.push("/windowedit/0");
    },
    windowEdit: function (id) {
      this.$store.commit("getProject", this.proj);
      this.$router.push("/windowedit/" + id);
    },
    windowDelete: function (win) {
      this.$store
        .dispatch("windowdelete", win)
        .then(response => {
          this.$store.dispatch("getwindows", this.projectId)
        })
        .catch(error => {
          if (typeof error.data === "string" || error.data instanceof String) {
            this.errors = {
              error: [error.data]
            };
          } else {
            this.errors = error.data;
          }
        });
    },
    windowCopy: function (win) {
      this.copywindow = win;
      this.winName = win.name;
      this.winNameEmpty = false;
      $('#CopyWindowName').modal('show');
    },
    winCopySend: function(){
      if (this.winName != ""){
        $('#CopyWindowName').modal('hide');
        var newwin = this.copywindow;
        newwin.Name = this.winName;
        this.$store
        .dispatch("windowpost", newwin)
        .then(response => {
          this.$store.dispatch("getwindows", this.projectId)
        })
        .catch(error => {
          if (typeof error.data === "string" || error.data instanceof String) {
            this.errors = {
              error: [error.data]
            };
          } else {
            this.errors = error.data;
          }
        });
      } else {
        this.winNameEmpty = true;
      }
    },
    windowBom: function (win) {
      this.$store.commit("setWindow", win);
      this.$router.push("/bom/" + win.id);
    },
    windowPdf: function (win) {
      $('#PDFPagesSelection').modal('show');
      this.selWin = win.id;
    },
    genericPdf: function (win) {
      this.selWin = win.id;
      this.$store.dispatch("genericpdf", win.id);
    },
    
    chrono(c){
      let chr = this.getChrono.find(o => o.chronoId == c);
      return chr.chronoDesc;
    },
    type(w){
      return this.$store.state.type[w];
    },
    handle(h){
      let han = this.getHandle.find(o => o.handleId == h);
      return han.handleDesc;
    },
    hinge(h){
      let hin = this.getHinge.find(o => o.hingeId == h);
      return hin.hingeDesc;
    },
    opdir(o){
      let opd = this.getOpDir.find(d => d.openId == o);
      return opd.openDesc;
    },
    groove(g){
      let gro = this.getGroove.find(e => e.grooveId == g);
      return gro.grooveDesc;
    },
    showProjectlist(){
      this.$store.commit("resetProject");
      this.$router.push("/projects/0");
    },
    handleBMP(anr){
      var han = this.$store.getters.getHandleByAN(anr);
      if (han != null)
        return han.bmp
        else
        return null;
    },
    handleAN(anr){
      var han = this.$store.getters.getHandleByAN(anr);
      if (han != null)
        return han.ext
        else
        return null;
    },
    caption(term){
      var cpt = this.$store.getters.getTranslationByTerm(term);
      return cpt.caption;
    },
    handleFileUpload(){
    this.file = this.$refs.file.files[0];
    this.uploadcaption = this.file.name;
    },
    submitFile(){
      var formdata  = new FormData();
      this.$store.commit("resetErrors");
      formdata.append('file', this.file);
      this.$store
        .dispatch("uploadfile", formdata)
        .then((response) => {
          $('#UploadModal').modal('show');
          const payload = this.$route.params.id;
          this.projectId = payload;
          this.$store.dispatch("getwindows", payload);
        });
    },
    closeModal(){
      $('#UploadModal').modal('hide');
      this.$store.commit("resetInvalidFile");
    },
    starttour: function(){
      this.$tours['WindowTour'].start()
    },
    myTourStart: function(){
      this.tour=true;
    },
    myTourStop: function(){
      this.tour=false;
    },
    showConfirmDelete(win){
      this.wintodelete = win;
      $('#ConfirmDelete').modal('show');
    },
    setSort(so){
    this.sortoptions = so;
    this.$store.commit('setWindowSortOptions', so);
    },
    setfirstpage(){
      if (this.firstpage == '1')
      {this.firstpage = '0'}
      else
      {this.firstpage = '1'};
    },
    setsashpage(){
      if (this.sashpage == '1')
      {this.sashpage = '0'}
      else
      {this.sashpage = '1'};
    },
    setframepage(){
      if (this.framepage == '1')
      {this.framepage = '0'}
      else
      {this.framepage = '1'};
    },
    pdfpageshide(){
      $('#PDFPagesSelection').modal('hide');
      if (this.firstpage != '0' || this.sashpage != '0' || this.framepage != '0')
      this.$store.dispatch("windowpdf", {id: this.selWin, pages: this.firstpage + this.sashpage + this.framepage});
    },
    wincopyModalHide() {
      $("#CopyWindowName").modal("hide");
    },
    pdfpagesmodalhide(){
      $('#PDFPagesSelection').modal('hide');
    },
    getprojreadonly(pid){
      return this.$store.getters.getprojro(pid);
    }
  },
  beforeMount(){
    this.uploadcaption = this.caption("upload_select");
  },
  
  mounted() {
    const payload = this.$route.params.id;
    this.projectId = payload;
    this.$store.dispatch("getwindows", payload);
    $(document).ready(function(){
     $(window).scroll(function () {
            if ($(this).scrollTop() > 50) {
                $('#back-to-top').show();
            } else {
                $('#back-to-top').hide();
            }
        });
        // scroll body to 0px on click
        $('#back-to-top').click(function () {
            $('#back-to-top').tooltip('hide');
            $('body,html').animate({
                scrollTop: 0
            }, 800);
            return false;
        });
        
        $('#back-to-top').tooltip('show');

});
  },
}
</script>

<style scoped>
    @media (min-width: 800px) {
        .container-fluid {
        width: 75%;
        }
    }
    .back-to-top {
        cursor: pointer;
        position: fixed;
        bottom: 20px;
        right: 20px;
        display:none;
    }
    .centered-and-cropped { object-fit: contain }
</style>



// WEBPACK FOOTER //
// src/components/windows/WindowList.vue